<template>
  <v-container v-if="isFilterEnabled" class="table-filter-container">
    <v-row>
      <v-form ref="form">
        <v-row justify="space-around">
          <template v-for="(groupFilter, index) in filters"  >
            <v-col md="3" cols="12" :key="`column_${index}`">
            <FilterItem
              v-for="(value, index) in groupFilter"
              :key="`${value.value}_${index}`"
              :modelItem="$store.state.dtableFilter.model[filterName][value.value]"
              :configs="value"
              :ref="`${value.value}`"
              :filterName="filterName"
              @updateValue="(v) => { $store.state.dtableFilter.model[filterName][value.value] = v }"
            >
            </FilterItem>
            </v-col>
          </template>

      </v-row>
      </v-form>
    </v-row>
    <v-row align-content="end" class="text-right">
      <v-btn
        outlined
        color="primary"
        @click="filterTable(false)">
        {{ $t('navbar:filter.filter') }}
      </v-btn>
      <v-btn
        outlined
        color="primary"
        class="ml-2"
        @click="filterTable(true)">
        {{ $t('navbar:filter.reset') }}
      </v-btn>
    </v-row>
    <v-row>

    </v-row>
  </v-container>
</template>

<script>
import FilterItem from '@/modules/core/components/DataTable/DataTablePaginated/FilterItem';

export default {
  name: 'TableFilter',
  components: {
    FilterItem
  },
  props: {
    filterName: null,
    headers: Array,
    headerSet: Array
  },
  data() {
    return {
      selectItems: [],
      isFilterEnabled: false,
      loadedElementsCount: 0,
      allElementCount: null
    }
  },
  computed: {
    filters() {
      let filters = [];
      let headers = typeof this.headers !== 'undefined' && this.headers.length > 0 ? this.headers : this.headerSet;
      for (let i = 0; i < headers.length; i++) {
        if (typeof headers[i].filter !== 'undefined') {
          let labels = typeof headers[i].filter.labels !== 'undefined'
            ? [this.$t('navbar:filter.not-selected')].concat(headers[i].filter.labels) : [];
          let hint = typeof headers[i].filter.hint !== 'undefined' ? headers[i].filter.hint : false;
          let options = typeof headers[i].filter.options !== 'undefined' ? headers[i].filter.options : false;
          let filterData = {
            value: headers[i].value,
            type: headers[i].filter.type,
            text: headers[i].text,
            enum: typeof headers[i].filter.enum !== 'undefined' ? headers[i].filter.enum : false,
            options: typeof headers[i].filter.optionsName !== 'undefined' ? headers[i].filter.optionsName : '',
            order: typeof headers[i].filter.order !== 'undefined' ? headers[i].filter.order : 0,
            translate: typeof headers[i].filter.forceTranslate !== 'undefined' ? headers[i].filter.forceTranslate : false,
            translateFn: typeof headers[i].filter.translateFn !== 'undefined' ? headers[i].filter.translateFn : null,
            url: typeof headers[i].filter.url !== 'undefined' ? headers[i].filter.url : null,
            invokeFns: typeof headers[i].filter.invokeFns !== 'undefined' ? headers[i].filter.invokeFns : null,
            clearable: typeof headers[i].filter.clearable !== 'undefined' ? headers[i].filter.clearable : true,
            labels: labels,
            hint: hint,
            loadedOptions: options,
            preselect: typeof headers[i].filter.preselect !== 'undefined' ? headers[i].filter.preselect : null,
          };
          let group = typeof headers[i].filter.group !== 'undefined' ? headers[i].filter.group : 0;

          if (filters[group]) {
            filters[group].push(filterData);
          } else {
            filters[group] = [filterData];
          }
        }
      }

      this.sortFilter(filters);
      this.$store.commit('dtableFilter/setFilter', {key: this.filterName, filter: filters});
      return this.$store.state.dtableFilter.filters[this.filterName];
    }

  },
  created() {
    if (typeof this.filterName === 'undefined' || this.filterName === null) return;

    this.isFilterEnabled = true;
    let filterModel = {};
    if (!this.$store.state.dtableFilter.model[this.filterName]) {
      this.filters.forEach(
        (filters) => {
          for (let i = 0; i < filters.length; i++) {
            filterModel[filters[i].value] = null;
          }
        }
      );
      this.$store.commit('dtableFilter/setModel', {key: this.filterName, model: filterModel});
    }
  },
  methods: {
    filterTable(shouldReset) {
      let model = this.$store.state.dtableFilter.model[this.filterName];
      if (shouldReset) {
        for (let key in  model) {
          model[key] = null;
          this.$refs[key][0].resetValue();
        }
      }
      this.$emit('changeFilter', this.$store.state.dtableFilter.model[this.filterName]);
    },
    sortFilter(filter) {
      filter.forEach(
        (item) => {
          item.sort((a, b) => {
            if(a.order < b.order) {
              return -1;
            }

            if(a.order > b.order) {
              return 1;
            }

            return 0;
          });
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.v-form {
  width: 100%;
}
</style>

